// extracted by mini-css-extract-plugin
module.exports = {"topbar":"Topbar_topbar__3RTl6","menuButton__wrapper":"Topbar_menuButton__wrapper__1ugvy","logo":"Topbar_logo__3BacD"};